module.exports = __webpack_public_path__ + "img/Icon-Chat.021ae0c9.svg";